function Measure(map, options) {
  let n;
  let i;
  let r;
  let o;
  let s;

  const a = options.distanceValueTarget
    ? options.distanceValueTarget
    : document.createElement("div");

  const u = !!options.bearingValueTarget && options.bearingValueTarget;
  let h = [];
  const l = {};
  let c = "IMPERIAL";
  let f = true;
  let d = 0;
  let p = "ML-0";
  const g = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

  const y = new ol.layer.Vector({
    source: new ol.source.Vector(),
    style: new ol.style.Style({
      fill: new ol.style.Fill({ color: "rgba(255, 255, 255, 0.2)" }),
      stroke: new ol.style.Stroke({ color: "#d1001c", width: 1 }),
      image: new ol.style.Circle({
        radius: 7,
        fill: new ol.style.Fill({ color: "#ffcc33" }),
      }),
    }),
  });

  map.addLayer(y);

  this.pointerMoveHandler = (t) => {
    if (!map.dragging) {
      let o = "Click to start";
      if (n) {
        const s = n.getGeometry();

        if (s instanceof ol.geom.Polygon) {
          o = "Click to continue drawing the polygon";
        } else if (s instanceof ol.geom.LineString) {
          o = "Click to end";
        }
      }

      if (options.helpValueTarget) {
        options.helpValueTarget.innerHTML = o;
      } else if (i) {
        i.innerHTML = o;
        r.setPosition(map.coordinate);
        i.classList.remove("hidden");
      }
    }
  };

  map.on("pointermove", this.pointerMoveHandler);

  map.getViewport().addEventListener("mouseout", () => {
    if (i) {
      i.classList.add("hidden");
    }
  });

  this.typeSelect = "length";
  this.draw;
  this.snap;
  const v = (t) =>
    c === "FT"
      ? `${(3.28084 * t).toLocaleString(undefined, g)} ft`
      : c === "M"
      ? `${(Math.round(100 * t) / 100).toLocaleString(undefined, g)} m`
      : c === "MI"
      ? `${(0.00062137 /* 62137e-8 */ * t).toLocaleString(undefined, g)} mi`
      : c === "KM"
      ? `${(Math.round((t / 1000) /* 1e3 */ * 100) / 100).toLocaleString(
          undefined,
          g
        )} km`
      : c === "IMPERIAL"
      ? f
        ? `${(0.00053996 /* 53996e-8 */ * t).toLocaleString(undefined, g)} nm`
        : t >= 1609.3
        ? f
          ? `${(0.00053996 /* 53996e-8 */ * t).toLocaleString(undefined, g)} nm`
          : `${(0.00062137 /* 62137e-8 */ * t).toLocaleString(undefined, g)} mi`
        : `${(3.28084 * t).toLocaleString(undefined, g)} ft`
      : c === "METRIC"
      ? t >= 1000 /* 1e3 */
        ? `${(Math.round((t / 1000) /* 1e3 */ * 100) / 100).toLocaleString(
            undefined,
            g
          )} km`
        : `${(Math.round(100 * t) / 100).toLocaleString(undefined, g)} m`
      : 0;
  this.addInteraction = function () {
    let r;

    this.draw = new ol.interaction.Draw({
      maxPoints: 2,
      source: y.getSource(),
      type: "LineString",
      condition(t) {
        return true;
      },
      style: new ol.style.Style({
        fill: new ol.style.Fill({ color: "rgba(255, 255, 255, 0.2)" }),
        stroke: new ol.style.Stroke({
          color: "rgba(0, 0, 0, 0.9)",
          lineDash: [5, 5],
          width: 1,
        }),
        image: new ol.style.Circle({
          radius: options.radius ? options.radius : 4,
          stroke: new ol.style.Stroke({
            color: options.pointerStroke ? options.pointerStroke : "rgba(0, 0, 0, 0.7)",
          }),
          fill: new ol.style.Fill({
            color: options.pointerFill ? options.pointerFill : "rgba(255, 255, 255, 0.2)",
          }),
        }),
      }),
    });

    map.addInteraction(this.draw);

    if (options.snap == 1) {
      this.snap = new ol.interaction.Snap({ source: y.getSource() });
      map.addInteraction(this.snap);
      this.snap.setActive(true);
    }

    if (!options.helpValueTarget) {
      m();
    }

    this.draw.on("drawstart", (e) => {
      p = `ML-${d++}`;
      a.innerHTML = "";

      if (u) {
        u.innerHTML = "";
      }

      if (!o) {
        _();
      }

      if (!i) {
        m();
      }

      n = e.feature;
      let e_coordinate = e.coordinate;
      r = n.getGeometry().on("change", (e) => {
        let n;
        const e_target = e.target;

        if (e_target instanceof ol.geom.LineString) {
          n = ((e) => {
            var n = ol.sphere.getLength(e);
            if (u) {
              let n = e.getCoordinates();

              let i = ol.proj.toLonLat(
                n[n.length - 1],
                map.getView().getProjection()
              );

              let r = ol.proj.toLonLat(
                n[n.length - 2],
                map.getView().getProjection()
              );

              u.innerHTML = x(r[1], r[0], i[1], i[0]).toFixed(2);
            }
            return v(n);
          })(e_target);

          e_coordinate = e_target.getLastCoordinate();
        }

        s.getElement().innerHTML = n;
        a.innerHTML = n;
        s.setPosition(e_coordinate);
      });
    });

    this.draw.on("drawend", (i) => {
      try {
        let i_feature = i.feature;
        let u = ol.sphere.getLength(i_feature.getGeometry());
        if (u > 0) {
          console.log(`LINE LENGTH:${u}`);
          i_feature.set("type", "MEASURE_LINE");
          i_feature.set("name", "Measure Line");
          i_feature.set("length", u);

          let e = i_feature
            .getGeometry()
            .clone()
            .transform(map.getView().getProjection(), "EPSG:4326");

          let n = ol.GeomUtils.createGreatCircleLineGeometry(
            e.getFirstCoordinate(),
            e.getLastCoordinate()
          );

          i_feature.setGeometry(
            n.transform("EPSG:4326", map.getView().getProjection())
          );

          i_feature.setId(p);
          o.className = "ol-tooltip ol-tooltip-static";
          s.setOffset([0, -5]);
          l[p] = { feature: i_feature, overlay: s };
        } else {
          map.removeOverlay(s);
        }
        n = null;
        o = null;
        _();

        if (!options.helpValueTarget) {
          m();
        }

        ol.Observable.unByKey(r);
      } catch (t) {
        console.error(`Measure error on drawend: ${t}`);
      }
    });

    this.draw.setActive(false);
  };

  var m = () => {
    if (!options.helpValueTarget) {
      i && i.parentNode.removeChild(i);
      i = document.createElement("div");
      i.className = "ol-tooltip hidden";

      r = new ol.Overlay({
        element: i,
        offset: [15, 0],
        positioning: "center-left",
      });

      map.addOverlay(r);
    }
  };

  var _ = () => {
    try {
      if (o) {
        o.parentNode.removeChild(o);
      }

      o = document.createElement("div");
      o.id = `tooltip-elem-${d}`;
      o.className = "ol-tooltip ol-tooltip-measure";

      s = new ol.Overlay({
        id: p,
        element: o,
        offset: [0, -15],
        positioning: "bottom-center",
      });

      h.push(s);
      map.addOverlay(s);
      return s;
    } catch (t) {
      alert(`Exception on createMeasureTooltip. ${t}`);
    }
  };

  this.addInteraction();

  this.activate = function () {
    this.draw.setActive(true);

    if (this.snap) {
      this.snap.setActive(true);
    }

    y.setZIndex(1000 /* 1e3 */);

    if (!options.helpValueTarget) {
      m();
    }
  };

  this.deactivate = function () {
    if (a) {
      a.innerHTML = "";
    }

    if (u) {
      u.innerHTML = "";
    }

    if (s) {
      s.setPosition(undefined);
      o = null;
    }

    if (r) {
      r.setPosition(undefined);
    }

    options.helpValueTarget || null;
    this.draw.setActive(false);

    if (this.snap) {
      this.snap.setActive(false);
    }
  };

  this.isActive = function () {
    return this.draw.getActive();
  };

  this.setImperialNm = () => {
    c = "IMPERIAL";
    f = true;
  };

  this.setImperialMi = () => {
    c = "IMPERIAL";
    f = false;
  };

  this.setMetric = () => {
    c = "METRIC";
  };

  this.setMeasureUnitFeet = () => {
    c = "FT";
    f = false;
  };

  this.setMeasureUnitMeters = () => {
    c = "M";
    f = false;
  };

  this.setMeasureUnitMiles = () => {
    c = "MI";
    f = false;
  };

  this.setMeasureUnitKilometers = () => {
    c = "KM";
    f = false;
  };

  this.setMeasureUnit = function (t) {
    switch (t) {
      case "IMPERIAL":
        this.setImperialMi();
        break;
      case "Nm":
        this.setImperialNm();
        break;
      case "METRIC":
        this.setMetric();
        break;
      case "ft":
        this.setMeasureUnitFeet();
        break;
      case "m":
        this.setMeasureUnitMeters();
        break;
      case "mi":
        this.setMeasureUnitMiles();
        break;
      case "km":
        this.setMeasureUnitKilometers();
        break;
    }
  };

  this.addMeasureStartHandler = function (t) {
    this.draw.on("drawstart", t);
  };

  this.clearAll = function () {
    y.getSource().clear(false);
    for (let t = 0; t < h.length; ++t) {
      this.remove(h[t]);
    }
    h = [];
  };

  this.remove = (e) => {
    let n = y.getSource().getFeatureById(`F-${e.getId()}`);

    if (n) {
      y.getSource().removeFeature(n);
    }

    map.removeOverlay(e);
  };

  this.removeMeasurement = (e) => {
    let l_e = l[e];

    if (l_e) {
      l_e.feature && y.getSource().removeFeature(l_e.feature);
      l_e.overlay && map.removeOverlay(l_e.overlay);
    }
  };

  this.metersToUnitLength = (t) => v(t);

  var x = (t, e, n, i) => {
    t *= Math.PI / 180;
    n *= Math.PI / 180;
    e *= Math.PI / 180;
    i *= Math.PI / 180;
    let r = Math.sin(i - e) * Math.cos(n);

    let o =
      Math.cos(t) * Math.sin(n) - Math.sin(t) * Math.cos(n) * Math.cos(i - e);

    let s = Math.atan2(r, o) * (180 / Math.PI);

    if (s < 0) {
      s += 360;
    }

    return s;
  };
}
export default Measure;
